module.exports = __webpack_public_path__ + "img/title.c5af262f.png";